import Vue from 'vue'
import Vuex from 'vuex'
import lscache from 'lscache'

Vue.use(Vuex)

const FFQsData = lscache.get('FFQsData')

const questionAmount = 60
const qsDataInit = {}
for (let i = 0; i < questionAmount; i++) {
  qsDataInit[i + 1] = {
    answer: [],
    input: '',
  }
}

export default new Vuex.Store({
  state() {
    return FFQsData
      ? FFQsData
      : {
          utm: {},
          userEmail: '',
          progress: 0,
          answerQsNumber: 0,
          qsData: qsDataInit,
          operationData: {},
          product: [],
          suggestion: [],
          reminder: [],
        }
  },
  mutations: {
    initData(state) {
      const initData = {}
      for (let i = 0; i < questionAmount; i++) {
        initData[i + 1] = {
          answer: [],
          input: '',
        }
      }
      state.utm = {}
      state.userEmail = ''
      state.progress = 0
      state.answerQsNumber = 0
      state.qsData = initData
      state.operationData = {}
      state.product = []
      state.suggestion = []
      state.reminder = []
      // 初始化缓存
      lscache.set('FFQsData', state, 60 * 24)
    },
    changeQsData(state, payload) {
      state.qsData[payload.id] = payload.data

      // 存入缓存
      // 过期时间1天
      lscache.set('FFQsData', state, 60 * 24)
    },
    changeOperationData(state, payload) {
      state.operationData[payload.id] = payload.data

      // 存入缓存
      lscache.set('FFQsData', state, 60 * 24)
    },
    changeReportData(state, payload) {
      const idx = state[payload.object].indexOf(payload.item)
      if (payload.action === 'add' && idx === -1) {
        state[payload.object].push(payload.item)
      } else if (payload.action === 'remove' && idx !== -1) {
        state[payload.object].splice(idx, 1)
      }

      // 存入缓存
      lscache.set('FFQsData', state, 60 * 24)
    },
    changeProgress(state, payload) {
      state.progress = payload.percent
    },
    changeAnswerQsNumber(state, { number }) {
      state.answerQsNumber = number
    },
    updateUTM(state, { key, value }) {
      state.utm[key] = value
    },
    addUserEmail(state, { email }) {
      state.userEmail = email
    },
  },
  actions: {
    generateReportData(context) {
      context.state.product = []
      context.state.suggestion = ['1']
      context.state.reminder = []
      const addList = []
      const removeList = []

      // 判断标志
      let flag1_4 = []
      let flag3_1 = []
      let flag3_3 = []

      for (let key in context.state.operationData) {
        context.state.operationData[key].forEach((val) => {
          let [action, param1] = val.split(' ')
          switch (action) {
            case 'add':
              addList.push(val)
              break

            case 'remove':
              removeList.push(val)
              break

            case 'flag1-4':
              flag1_4.push(param1)
              break

            case 'flag1-4_None_add':
              flag1_4.indexOf('None') !== -1 &&
                addList.push(val.slice(val.indexOf('add')))
              break

            case 'flag1-4_Prepare_add':
              flag1_4.indexOf('Prepare') !== -1 &&
                addList.push(val.slice(val.indexOf('add')))
              break

            case 'flag1-4_Pregnancy_add':
              flag1_4.indexOf('Pregnancy') !== -1 &&
                addList.push(val.slice(val.indexOf('add')))
              break

            case 'flag1-4_Lactation_add':
              flag1_4.indexOf('Lactation') !== -1 &&
                addList.push(val.slice(val.indexOf('add')))
              break

            case 'flag1-4_Menopause_add':
              flag1_4.indexOf('Menopause') !== -1 &&
                addList.push(val.slice(val.indexOf('add')))
              break

            case 'flag3-1':
              flag3_1.push(param1)
              break

            case 'flag3-1_Vegan_add':
              flag3_1.indexOf('Vegan') !== -1 && addList.push(val.slice(14))
              break

            case 'flag3-1_Pescatarian_add':
              flag3_1.indexOf('Pescatarian') !== -1 &&
                addList.push(val.slice(20))
              break

            case 'flag3-1_Anything_add':
              flag3_1.indexOf('Anything') !== -1 && addList.push(val.slice(17))
              break

            case 'flag3-3':
              flag3_1.indexOf('Anything') !== -1 && flag3_3.push(param1)
              break

            case 'flag3-3_true_add':
              flag3_3.indexOf('true') !== -1 && addList.push(val.slice(13))
              break
          }
        })
      }

      // 先加后减
      addList.forEach((val) => {
        let [action, object, item] = val.split(' ')
        context.commit({
          type: 'changeReportData',
          action: action,
          object: object,
          item: item,
        })
      })
      removeList.forEach((val) => {
        let [action, object, item] = val.split(' ')
        context.commit({
          type: 'changeReportData',
          action: action,
          object: object,
          item: item,
        })
      })
    },
  },
  modules: {},
})
